import FakeButton from "@/components/fake-button";

type Props = {
  maintenanceMessage: string;
};

const Maintenance = ({ maintenanceMessage }: Props) => {
  return (
    <FakeButton size="4xl" className="grow-3 leading-tight">
      <p className="wrap-break-word text-3xl leading-tight">
        {maintenanceMessage}
      </p>
    </FakeButton>
  );
};

Maintenance.displayName = "Maintenance";
export default Maintenance;
